import AudioContext from './AudioContext';

let Recorder;

Recorder = require('./RecorderScriptProcessor').default;

// audioWorklet implementation doesn't work in Chrome
if (false && 'audioWorklet' in AudioContext.prototype) {
  Recorder = require('./RecorderWorklet').default;
}

export default Recorder;



// WEBPACK FOOTER //
// ./src/Recorder.js